import React from "react";
import jetblackBg from "../assets/images/jetblack-bg.png";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const InfoPage = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! Your VIP assistance request has been sent.");
    // Aquí podrías agregar la lógica para enviar el formulario.
  };

  return (
    <div className="info-page">
      {/* Sección Hero con imagen de fondo y texto lateral */}
      <div className="hero">
        <img src={jetblackBg} alt="Jet Black Background" className="hero-image" />
        <div className="hero-text">
          <h1>Your Luxury Ride Awaits</h1>
          <p>Experience unmatched service and comfort</p>
        </div>
      </div>

      {/* Bloque de tres tarjetas de información */}
      <div className="cards-container">
        <div className="card">
          <FaMapMarkerAlt className="card-icon" />
          <h3>Location</h3>
          <p>Yorktown Heights, NY</p>
        </div>
        <div className="card">
          <FaPhoneAlt className="card-icon" />
          <h3>Phone</h3>
          <p>+1 (914) 962-8444</p>
        </div>
        <div className="card">
          <FaEnvelope className="card-icon" />
          <h3>Email</h3>
          <p>jetblacklimo@aol.com</p>
        </div>
      </div>

      {/* Sección de Mapa y Formulario de Contacto (lado a lado) */}
      <div className="map-form-container">
        {/* Mapa */}
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11924.23739004644!2d-73.7414121!3d41.4763134!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2b7a158aac975%3A0x1c4c799c94732753!2sJet%20Black%20Limousine!5e0!3m2!1sen!2sus!4v1673452458886!5m2!1sen!2sus"
            title="Location"
            className="map"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>

        {/* Formulario de contacto */}
        <div className="form-container">
          <form className="vip-form" onSubmit={handleSubmit}>
            <h3 className="form-title">Request VIP Assistance</h3>
            <input type="text" placeholder="Name" className="input" required />
            <input type="email" placeholder="Email" className="input" required />
            <input type="text" placeholder="Phone" className="input" required />
            <textarea placeholder="Your Message" className="textarea" required></textarea>
            <button type="submit" className="button">
              Send Request
            </button>
          </form>
        </div>
      </div>

      {/* Estilos inyectados */}
      <style>
        {`
          .info-page {
            width: 100%;
            font-family: "Merriweather", serif;
          }
          /* Sección Hero */
          .hero {
            position: relative;
            width: 100%;
            height: 500px; /* Aumentamos la altura para resaltar el fondo */
            overflow: hidden;
            margin-bottom: 40px; /* Mayor separación debajo del hero */
          }
          .hero-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          /* Se elimina el fondo del texto para no tapar la imagen */
          .hero-text {
            position: absolute;
            top: 70%; /* Se mueve más abajo para dejar ver el fondo */
            left: 20px;
            transform: translateY(-70%);
            color: #fff;
            /* Se remueve el background-color */
            padding: 0;
            border-radius: 0;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.7);
          }
          .hero-text h1 {
            margin: 0;
            font-size: 2.8rem;
          }
          .hero-text p {
            margin-top: 10px;
            font-size: 1.3rem;
          }
          /* Tarjetas de información */
          .cards-container {
            display: flex;
            justify-content: center;
            gap: 20px;
            margin: 40px auto;
            max-width: 1200px;
          }
          .card {
            background-color: #fff;
            padding: 20px;
            border-radius: 12px;
            width: 300px;
            text-align: center;
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .card:hover {
            transform: translateY(-10px);
            box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3);
          }
          .card-icon {
            font-size: 3rem;
            color: #0d2b3e;
            margin-bottom: 10px;
            transition: filter 0.3s ease;
          }
          .card:hover .card-icon {
            filter: brightness(150%);
          }
          .card h3 {
            margin: 0;
            font-size: 1.5rem;
            color: #0d2b3e;
            text-shadow: 1px 1px 4px rgba(0,0,0,0.3);
          }
          .card p {
            margin: 5px 0 0;
            font-size: 1.2rem;
            color: #333;
          }
          /* Sección de Mapa y Formulario */
          .map-form-container {
            display: flex;
            justify-content: center;
            align-items: flex-start;
            gap: 40px;
            max-width: 1200px;
            margin: 40px auto;
          }
          .map-container {
            flex: 1;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
          }
          .map {
            width: 100%;
            height: 400px;
            border: none;
          }
          .form-container {
            flex: 1;
          }
          .vip-form {
            background-color: #fff;
            padding: 20px 30px;
            border-radius: 12px;
            box-shadow: 0 6px 12px rgba(0,0,0,0.15);
            display: flex;
            flex-direction: column;
            gap: 15px;
          }
          .form-title {
            font-size: 2rem;
            font-weight: bold;
            color: #0d2b3e;
            text-align: center;
            margin-bottom: 10px;
            text-shadow: 1px 1px 4px rgba(0,0,0,0.3);
          }
          .input, .textarea {
            width: 100%;
            padding: 12px;
            font-size: 1rem;
            border: 2px solid #ccc;
            border-radius: 6px;
            transition: border-color 0.3s ease;
          }
          .input:focus, .textarea:focus {
            border-color: #0d2b3e;
            outline: none;
          }
          .textarea {
            resize: vertical;
            height: 120px;
          }
          .button {
            padding: 14px;
            background-color: #0d2b3e;
            color: #fff;
            border: none;
            border-radius: 6px;
            font-size: 1.3rem;
            font-weight: bold;
            cursor: pointer;
            transition: background-color 0.3s ease, transform 0.2s ease;
            box-shadow: 0 4px 8px rgba(0,0,0,0.2);
          }
          .button:hover {
            background-color: #09202e;
            transform: translateY(-3px);
          }
          .button:active {
            transform: translateY(0);
          }
        `}
      </style>
    </div>
  );
};

export default InfoPage;
